var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercardBgblack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2e3341",
    fillRule: "evenodd",
    d: "M3.53 0h45.92a3.53 3.53 0 013.53 3.53V25.9a3.53 3.53 0 01-3.53 3.53H3.53A3.53 3.53 0 010 25.9V3.53A3.53 3.53 0 013.53 0z",
    className: "mastercard-bgblack_svg__cls-12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5f00",
    d: "M22.41 8.86h7.85v13.5h-7.85V8.86z",
    className: "mastercard-bgblack_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eb001b",
    d: "M23.27 15.36a8.48 8.48 0 013.33-6.72 8.86 8.86 0 00-5.4-1.83 8.64 8.64 0 00-8.75 8.55 8.64 8.64 0 008.75 8.54 8.8 8.8 0 005.4-1.83 8.44 8.44 0 01-3.33-6.71z",
    className: "mastercard-bgblack_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f79e1b",
    d: "M40.74 15.36a8.64 8.64 0 01-8.75 8.54 8.75 8.75 0 01-5.39-1.83 8.41 8.41 0 003.33-6.71 8.51 8.51 0 00-3.33-6.72 8.81 8.81 0 015.39-1.83 8.66 8.66 0 018.75 8.55z",
    className: "mastercard-bgblack_svg__cls-15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardBgblack);
export default __webpack_public_path__ + "static/media/mastercard-bgblack.f343a582eb0306a23561fe56f8e6af6d.svg";
export { ForwardRef as ReactComponent };